$(document).ready(function() {
  var MOUSE_EVENTS = ["click", "touchstart"];

  $(".skip-report").on("click", function(e) {
    $(e.target.form).prop("noValidate", true);
  });

  // Confirm dialogues
  var formsToConfirm = $("form[data-confirm]");
  [].forEach.call(formsToConfirm, function(formToConfirm) {
    $(formToConfirm).submit(function(e) {
      const submitter = e.originalEvent.submitter.attributes["name"].value;
      var status = confirm(
        submitter === "skip_report_grant"
          ? "Are you sure you want to skip filing this report?"
          : e.currentTarget.dataset["confirm"]
      );
      if (status === false) {
        e.preventDefault();
      }
    });
  });

  // Accordions
  if ($("#grant-form")[0]) {
    var accordions = document.querySelectorAll(".accordions");
    [].forEach.call(accordions, function(accordion) {
      var items = accordion.querySelectorAll(".accordion");

      [].forEach.call(items, function(item) {
        MOUSE_EVENTS.forEach(event => {
          item
            .querySelector('.toggle, [data-action="toggle"]')
            .addEventListener(event, e => {
              e.preventDefault();
              if (!item.classList.contains("is-active")) {
                let activeItem = accordion.querySelector(
                  ".accordion.is-active"
                );
                if (activeItem) {
                  activeItem.classList.remove("is-active");
                }
                item.classList.add("is-active");
              } else {
                item.classList.remove("is-active");
              }
              $("html, body")
                .stop()
                .animate(
                  {
                    scrollTop: $(".accordion.is-active").offset().top - 100
                  },
                  1000
                );
            });
        });
      });
      if (!$("#grant-form")[0].checkValidity()) {
        $(".accordion").addClass("is-active");
      }
    });

    // Autosave form for grantees
    var form = $("#grant-form");
    if (form.data("autosave")) {
      $.ajaxSetup({
        headers: {
          "X-CSRF-Token": $('meta[name="csrf-token"]').attr("content")
        }
      });
      setInterval(function() {
        $.ajax({
          url: form.attr("action"),
          type: "PATCH",
          data: form.serialize(),
          success: function(response) {
            $("body").prepend(
              '<div class="notification is-success">Grant application autosaved</div>'
            );
            console.log("Autosaved successfully");
          },
          error: function(xhr, status, error) {
            $("body").prepend(
              '<div class="notification is-danger">Failed to autosave, please save and continue manually</div>'
            );
            console.log("Autosave failed:", error);
          }
        });
      }, 180000); // autosave every 3 minutes
    }
  }

  // Expand collapse all sections

  var collapse_button = document.querySelectorAll(".collapse-icon");
  if (collapse_button) {
    $(collapse_button[0]).click(event => {
      var icon = collapse_button[0].firstChild;
      var span = collapse_button[0].lastChild;
      $(icon)
        .toggleClass("fa-plus")
        .toggleClass("fa-minus");
      if (icon.classList.value.includes("fa-minus")) {
        span.innerText = "collapse all sections";
        $(".accordion").addClass("is-active");
      } else if (icon.classList.value.includes("fa-plus")) {
        span.innerText = "expand all sections";
        $(".accordion").removeClass("is-active");
      }
    });
  }

  //manage-sidebars
  function offsetBottom(el, i) {
    i = i || 0;
    return $(el)[i].getBoundingClientRect().bottom;
  }

  var dismissmanage_sidebar = document.querySelectorAll(
    '[data-dismiss="manage-sidebar"]'
  );

  [].forEach.call(dismissmanage_sidebar, function(dismiss) {
    // var manage_sidebar = closest(dismiss, '.manage-sidebar');
    var manage_sidebar = document.getElementById(dismiss.dataset["target"]);
    if (manage_sidebar) {
      // Add event listener to update output when slider value change
      MOUSE_EVENTS.forEach(event => {
        dismiss.addEventListener(event, function(e) {
          $(manage_sidebar).css({ top: offsetBottom("header") });
          manage_sidebar.classList.toggle("is-active");
          history.pushState(
            "",
            document.title,
            window.location.pathname + window.location.search
          );
        });
      });
    }
  });

  $(window).bind("scroll", function() {
    $("#manage-sidebar-main").css({ top: offsetBottom("header") });

    $("header")[($(window).scrollTop() > 125 ? "add" : "remove") + "Class"](
      "fixed"
    );

    $(".grant-form")[
      ($(window).scrollTop() > 165 ? "add" : "remove") + "Class"
    ]("fixed");

    $(".back-to-top")[
      ($(window).scrollTop() > 165 ? "add" : "remove") + "Class"
    ]("fixed");
  });

  // navbar hamburger
  $(".navbar-burger").click(function() {
    $("#mainNav").toggleClass("is-active");
    $(".navbar-burger").toggleClass("is-active");
  });

  // Tabs in general
  $(".panel").addClass("is-hidden");
  if (window.location.hash) {
    const hash = window.location.hash;
    const tab = hash.split("#")[1];
    const highlightItem = hash.split("#")[2];
    if (
      [
        "attachments",
        "comments",
        "history",
        "people",
        "endorse",
        "manage",
        "finance",
        "report",
        "closure"
      ].includes(tab)
    ) {
      $(dismissmanage_sidebar[0]).trigger("click");
    }
    $(".control-tabs li a[href='#" + tab + "']")
      .first()
      .parent()
      .addClass("is-active");
    $("#" + tab).removeClass("is-hidden");
    if (highlightItem) {
      $("#" + highlightItem)
        .addClass("active")
        .delay(10000)
        .queue(function() {
          $(this)
            .removeClass("active")
            .dequeue();
        });
    }
  } else {
    $(".control-tabs li:first").addClass("is-active");
    $(".panel:first").removeClass("is-hidden");
  }

  $(".control-tabs li a").click(function(e) {
    $(".control-tabs li").removeClass("is-active");
    $(this)
      .parent()
      .addClass("is-active");
    $(".panel").addClass("is-hidden");
    var tabToShow = $(this).attr("href");
    window.location.hash = tabToShow.replace("#", "");
    $(window.location.hash).removeClass("is-hidden");
    return false;
  });

  // alter cloned menu in footer
  $("footer .navbar-item")
    .removeClass("navbar-item has-dropdown is-hoverable")
    .addClass("column")
    .parent()
    .addClass("columns");
  $("footer .navbar-dropdown")
    .addClass("sub-menu")
    .removeClass("navbar-dropdown");
  $("footer .sub-menu").removeClass("columns");
  $("footer .sub-menu .column").removeClass("column");
  $("footer .navbar-link").removeClass("navbar-link");

  // Disable form validation for Save and Continue
  var save_and_continue = document.getElementsByClassName("save-and-continue");
  [].forEach.call(save_and_continue, function(sac) {
    if (sac) {
      MOUSE_EVENTS.forEach(event => {
        sac.addEventListener(event, function(e) {
          var parselyForm = $("#grant-form")
            .parsley()
            .destroy();
          $("form").prop("noValidate", true);
        });
      });
    }
  });

  // Open Submit and lock modal
  var submit_and_lock = document.getElementsByClassName(["submit-and-lock"]);
  [].forEach.call(submit_and_lock, function(sal) {
    if (sal) {
      MOUSE_EVENTS.forEach(event => {
        sal.addEventListener(event, function(e) {
          $(".modal.submit-lock").addClass("is-active");
        });
      });
    }
  });

  $(".show-summary").click(function() {
    $(".modal.modal-summary").addClass("is-active");
  });
  // Close modal
  var close_modal = document.getElementsByClassName("close-modal");
  [].forEach.call(close_modal, function(cm) {
    if (cm) {
      MOUSE_EVENTS.forEach(event => {
        cm.addEventListener(event, function(e) {
          if (e.target.classList.contains("apply")) {
            const parsleyForm = $("#grant-form").parsley("enabled");
            parsleyForm.validate();
            $(".modal.is-active").removeClass("is-active");
          } else {
            $(".modal.is-active").removeClass("is-active");
            var parselyForm = $("#grant-form")
              .parsley()
              .destroy();
          }
        });
      });
    }
  });

  $(document).keydown(function(e) {
    if (e.keyCode == 27) {
      $(".modal.is-active").removeClass("is-active");
    }
  });

  // remove notification bubble
  var intervalNotify = setInterval(function() {
    if ($(".notification").length) {
      $(".notification")
        .delay(5000)
        .animate(
          {
            right: "-50%"
          },
          600,
          function() {
            $(".notification")
              .delay(1000)
              .remove();
          }
        );
    }
  }, 5000); // check if notification exists every 5 seconds

  // grant form switches
  var applying_for = document.getElementsByClassName("applying-for");
  var applied_for = $(applying_for).filter(":checked");
  if (applied_for.length) {
    check_checked_option(applied_for[0]);
  }
  function check_checked_option(e) {
    if (e.classList.contains("myself")) {
      $(".applying-for-fields input")
        .not(".applying-for-fields .gender input")
        .prop("disabled", true)
        .addClass("is-disabled");
      $(".applying-for-fields .organisation").addClass("is-hidden");
      $("#form_data_organization_network").val(
        $("#form_data_name_of_organisation").val()
      );
      $("#form_data_organization_first_name").val(
        $("#form_data_first_name").val()
      );
      $("#form_data_organization_last_name").val(
        $("#form_data_last_name").val()
      );
      $("#form_data_organization_email").val(
        $("#form_data_contact_email").val()
      );
      $("#form_data_organization_phone").val(
        $("#form_data_contact_telephone").val()
      );
    } else if (e.classList.contains("individual")) {
      $(".applying-for-fields input")
        .prop("disabled", false)
        .removeClass("is-disabled");
      $(".applying-for-fields .organisation").addClass("is-hidden");
      $("#form_data_organization_network").val("");
    } else {
      $(".applying-for-fields input").removeClass("is-disabled");
      $(".applying-for-fields .organisation").removeClass("is-hidden");
    }
  }
  [].forEach.call(applying_for, function(apply) {
    if (apply) {
      MOUSE_EVENTS.forEach(event => {
        apply.addEventListener(event, function(e) {
          check_checked_option(e.target);
        });
      });
    }
  });

  // Other buttons to load textboxes
  function show_other_text_box(e) {
    var textBoxId = e.id.replace("Other", "other").replace(":", "");
    if (e.tagName === "SELECT") {
      $("#" + e.id + "_other").removeClass("is-hidden");
    } else if (e.checked) {
      $("#" + textBoxId).removeClass("is-hidden");
    } else {
      $("#" + textBoxId)
        .addClass("is-hidden")
        .val("");
    }
  }

  var others = document.querySelectorAll(".Other");
  var othersToShow = $(others).filter(":checked");
  [].forEach.call(othersToShow, function(other) {
    show_other_text_box(other);
  });

  $(".Other").bind("change", function(e) {
    show_other_text_box(e.target);
  });

  $(
    "[name='profile[gender]'], [name='form_data[organization_gender]'], [name='form_data[address_country]']"
  ).change(function(e) {
    if (e.target.value === "Other") {
      show_other_text_box(e.target);
    } else {
      if (e.target.tagName === "SELECT") {
        $("#" + e.target.id + "_other")
          .addClass("is-hidden")
          .val("");
      } else {
        var str = e.target.name;
        var targetId =
          "#" +
          str.substring(str.indexOf("[") + 1, str.lastIndexOf("]")) +
          "_other";
        $(targetId)
          .addClass("is-hidden")
          .val("");
      }
    }
  });

  // Add .is-danger class to invalid inputs

  var inputs = document.querySelectorAll("input, select, textarea");

  inputs.forEach(input => {
    input.addEventListener(
      "invalid",
      event => {
        if (input.type === "radio") {
          input.parentNode.parentNode.classList.add("error");
        } else {
          input.classList.add("error");
        }
      },
      false
    );
    var inputToFocus = $(".error")[0];

    if (inputToFocus) {
      $(inputToFocus).focus({ focusVisible: true });
      $(window).scrollTop($(inputToFocus).positon().top);
    }
  });

  if (!("cookieMessage" in sessionStorage)) {
    $(".cookie-notice")
      .delay(3000)
      .animate(
        {
          bottom: "0px"
        },
        "slow"
      );
  }
  $(".cookie-close").bind("click", function(e) {
    $(".cookie-notice")
      .delay(500)
      .animate(
        {
          bottom: "-200px"
        },
        "slow"
      );
    sessionStorage.setItem("cookieMessage", true);
  });

  // prefix https for email website urls
  $("#form_data_social_website, #profile_website").on("blur focus", function(
    e
  ) {
    var v = e.target.value;
    // if (v === "" || v.startsWith("^(http|https)://")) {
    if (v === "" || !v.startsWith("http")) {
      e.target.value = `https://${e.target.value}`;
    }
    if (e.type === "blur" && v === "https://") {
      e.target.value = null;
    }
  });

  var bAmounts = document.querySelectorAll(".main-page .budget-amount");
  var bTot = document.getElementById("budget-total");
  var tot = document.getElementById("tot");
  if (bTot && !bTot.value) {
    a = 0;
    bAmounts.forEach(function(i, e) {
      a += parseFloat(i.value || 0);
    });
    bTot.value = a.toFixed(2);
    if (tot) {
      tot.value = bTot.value;
    }
  }
  $(document).on("keyup", ".budget-amount", function() {
    var bTotal = 0;
    bAmounts.forEach(function(i, e) {
      bTotal += parseFloat(i.value) || 0;
    });
    bTot.value = bTotal.toFixed(2);
  });

  // $("#export-to-pdf").click(function() {
  //   var $cloneForm = $("form#grant-form").clone();
  //   $cloneForm.find(":input", ":textarea", ":select").prop(("disabled", false));
  //   var fd = new FormData($cloneForm[0]);
  // });

  // Preload comment boxes with template chosen from dropdown
  var commentTemplates = $(".comment-templates");
  [].forEach.call(commentTemplates, function(ct) {
    $(ct).on("change", function(e) {
      const textarea = "textarea" + ct.dataset["for"];
      $(textarea)[0].innerHTML = $("option:selected", ct)[0].dataset["body"];
    });
  });

  $(".edit-funder").on("click", function() {
    $(".funder-edit")
      .addClass("is-flex")
      .removeClass("is-hidden");
    $(".funder-display").addClass("is-hidden");
  });
  $(".display-funder").on("click", function() {
    $(".funder-edit")
      .addClass("is-hidden")
      .removeClass("is-flex");
    $(".funder-display").removeClass("is-hidden");
  });
});
